module.exports = __webpack_public_path__ + "img/sv6on.6275d2f1.svg";